"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTopicFragmentDependencies = exports.userTopicFragment = void 0;
exports.userTopicFragment = `
fragment userTopicFragment on UserTopic {
  name
  topicName
  targetCollections
  targetTemplate
}
`.trim();
exports.userTopicFragmentDependencies = [];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlclRvcGljRnJhZ21lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvZnJhZ21lbnRzL3VzZXJUb3BpY0ZyYWdtZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsaUJBQWlCLEdBQUc7Ozs7Ozs7Q0FPaEMsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVJLFFBQUEsNkJBQTZCLEdBQUcsRUFBRSxDQUFDIn0=